<template>
  <select :class="'ql-' + type">
    <option v-for="color in pallete" :value="color"></option>
  </select>
</template>

<script>
import { colors } from 'src/helpers/textEditor/config';

export default {
  props: {
    type: String,
  },
  data() {
    return {
      pallete: colors,
    };
  },
};
</script>



/** WEBPACK FOOTER **
 ** Color.vue?4b3d1f1c
 **/